/**
 * Soft-editorial shadow tokens.
 *
 * The soft-editorial direction avoids harsh drop shadows. Only three depth
 * tiers exist; no "2xl" or dramatic elevation. Dark-mode shadows use slightly
 * stronger alpha because the surrounding surface is darker.
 */

export const shadows = {
  light: {
    card: "0 1px 2px rgba(20, 20, 23, 0.04), 0 1px 1px rgba(20, 20, 23, 0.03)",
    cardHover:
      "0 4px 12px rgba(20, 20, 23, 0.06), 0 2px 4px rgba(20, 20, 23, 0.04)",
    popover:
      "0 8px 24px rgba(20, 20, 23, 0.10), 0 2px 6px rgba(20, 20, 23, 0.06)",
  },
  dark: {
    card: "0 1px 2px rgba(0, 0, 0, 0.30), 0 1px 1px rgba(0, 0, 0, 0.20)",
    cardHover: "0 4px 12px rgba(0, 0, 0, 0.40), 0 2px 4px rgba(0, 0, 0, 0.25)",
    popover: "0 8px 24px rgba(0, 0, 0, 0.50), 0 2px 6px rgba(0, 0, 0, 0.30)",
  },
} as const;

export type ShadowToken = keyof typeof shadows.light;
